// Route wrappers for the Reporting pages that can open on one customer (the customer code comes from the address).
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ReportingCustomers from './ReportingCustomers';
import ReportingCustomerOverview from './ReportingCustomerOverview';
import ReportingUsageDetail from './ReportingUsageDetail';
import ReportingSessions from './ReportingSessions';

export function CustomersRoute() {
  const navigate = useNavigate();
  return <ReportingCustomers onOpenCustomer={(code) => navigate(`/reporting/customer-overview/${encodeURIComponent(code)}`)} />;
}

export function OverviewRoute() {
  const { code } = useParams();
  const navigate = useNavigate();
  return <ReportingCustomerOverview custCode={code} onSelectCustomer={(c) => navigate(c ? `/reporting/customer-overview/${encodeURIComponent(c)}` : '/reporting/customer-overview', { replace: true })} />;
}

export function UsageDetailRoute() {
  const { code } = useParams();
  return <ReportingUsageDetail custCode={code} />;
}

export function SessionsRoute() {
  const { code } = useParams();
  return <ReportingSessions custCode={code} />;
}
